import {Contact} from "../../../../../server/src/base/entities/contact/Contact";
import {IContactService} from "../../domain/mailing/IContactService";
import {ApiAccessService} from "../api/ApiAccessService";

export class ContactService implements IContactService{

    private apiAccessService:ApiAccessService;

    constructor(apiAccessService:ApiAccessService){
        this.apiAccessService = apiAccessService;
    }

    public SendEmail(contact: Contact): Promise<void> {
        return this.apiAccessService.Post("contact", contact);
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/mailing/ContactService.ts